import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import './documentation.css';
import { documentationData as data } from '../../../data/documentationData';
import Dashboard from '../dashboard/Dashboard';

const Documentation = () => {
  const location = useLocation();
  const [section, setSection] = useState(data[0].section);  // Initialize with the first element's section
  const [activeIndex, setActiveIndex] = useState(0);  // Initialize with 0
  
  useEffect(() => {
    // Update section and activeIndex when location changes
    const index = data.findIndex(item => item.section === location.pathname.slice(1));
    setSection(index !== -1 ? data[index].section : data[0].section);
    setActiveIndex(index !== -1 ? index : 0);
  }, [location]);
  
  const handleSectionChange = (index, item) => {
    setSection(item.section);
    setActiveIndex(index);
  };
  
  const handleSelectChange = (e) => {
    setSection(e.target[e.target.selectedIndex].label);
    setActiveIndex(e.target.selectedIndex);
  }
  
  const sidebarContent = <>{window.innerWidth > 768 ?
      <ul className='sidebar-list'>
      {data.map((item, index) => (
        <li
          className={`paragraph-sub-4 light-bold ${activeIndex === index ? 'active' : ''}`}
          onClick={() => handleSectionChange(index, item)}
          key={index}
        >
          {item.section}
        </li>
      ))
      }
    </ul>:
    <select className='input-full dropdown-dk-purple'
            onChange={(e) => handleSelectChange(e)}>
      {data.map((item, index) => (
      <option value={item.section}
              className={activeIndex === index ? 'active' : ''}
              key={index}>
        {item.section}
      </option>
      ))}
    </select>
  }</>;
  
  const filteredContent = section ?
    data.filter((item) =>
      item.section === section
    ) : '';
  
  const contentBoxContent = <div className='content'>
    <p className='light-bold' dangerouslySetInnerHTML={{__html: filteredContent[0]?.content}} />
  </div>;
  
  return (
    <Dashboard
      content={sidebarContent}
      section='DOCUMENTATION'
      contentBoxContent={contentBoxContent}
      contentBoxSection={section}
    />
  );
};

export default Documentation;
